<template>
  <div class="wrapper">
    <div class="list-grid">
      <template v-for="(item, i) in items">
        <Checkmark :key="`${i}-check`" />
        <span :key="i">{{ item }}</span>
      </template>
    </div>
  </div>
</template>

<script>
import Checkmark from "@/assets/svg/checkmark.svg";

export default {
  name: "CheckList",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  components: {
    Checkmark,
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: center;
}

.list-grid {
  display: grid;
  grid-template-columns: min-content minmax(auto, max-content);
  grid-row-gap: $spacing-xs;
  grid-column-gap: $spacing-xs;
  align-items: center;

  text-align: start;
  font-size: $subtitle-font-size;
  font-weight: $font-regular;
}
</style>
